import { render } from "./SegmentCard.vue?vue&type=template&id=17846ed2&scoped=true&lang=pug"
import script from "./SegmentCard.vue?vue&type=script&lang=js"
export * from "./SegmentCard.vue?vue&type=script&lang=js"

import "./SegmentCard.vue?vue&type=style&index=0&id=17846ed2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17846ed2"]])

export default __exports__